/**
 * Interface for the 'ShipmentAddresses' data
 */
export interface ShipmentAddress {
    id: number; // Primary ID
    address_type: string;
    name?: string;
    address_1?: string;
    address_2?: string;
    postal_code?: string;
    city?: string;
    state?: string;
    country_code?: string;
    contact_name?: string;
    phone_number?: string;
    email_address?: string;
    remarks?: string;
}
